import { RootState } from 'types/root-state';
import { configuratorsListingState } from './slice';

const selectDomain = (state: RootState) =>
	state.spl.configuratorsListing || configuratorsListingState;

export const selectConfigurators = (state: RootState) =>
	selectDomain(state).data.configurators || [];
export const selectBestsellers = (state: RootState) => selectDomain(state).data.bestsellers;
export const selectInstallationDeadline = (state: RootState) =>
	selectDomain(state).data.deadlines?.executionStart?.installationDays;
export const selectMeasureDeadline = (state: RootState) =>
	selectDomain(state).data.deadlines?.executionStart?.measureDays;
export const selectConfiguratorsNetwork = (state: RootState) => selectDomain(state).network;
export const selectCompensationStatus = (state: RootState) =>
	selectDomain(state).data.isCompensationEnabled;
export const selectConfiguratorsIds = (state: RootState) =>
	selectDomain(state).data.configurators.map(({ id }) => id);

export const selectRating = (state: RootState) => selectDomain(state).rating.data;
export const selectConfiguratorRating = (searchId: number) => (state: RootState) => {
	const { data } = selectDomain(state).rating;
	return (
		data.find(({ configuratorId }) => configuratorId === searchId) || {
			avgRating: 0,
			totalReviews: 0,
			configuratorId: searchId,
		}
	);
};

export const selectRatingNetwork = (state: RootState) => selectDomain(state).rating.network;
